import { ENABLED_CATEGORIES } from '@/types/career/route.types'

export default defineNuxtRouteMiddleware((to) => {
  const categories = Object.values(ENABLED_CATEGORIES) as string[]
  
  if (!categories.includes(to.params.category as string)) {
    throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
  } else {
    return categories.includes(to.params.category as string)
  }
})
